import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Search, Filter } from "lucide-react";
import { stageConfig, activePipelineStages } from "./constants";

export const PipelineFilters = ({
  searchTerm,
  setSearchTerm,
  stageFilter,
  setStageFilter,
  showClosed,
  setShowClosed,
}) => (
  <Card className="bg-[#0F0F3D] border-[#1E1E5F]">
    <CardContent className="pt-6">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input
            placeholder="Buscar por título, cliente, ID, ejecutivo..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 bg-[#0A0A35] border-[#1E1E5F] text-white"
            data-testid="search-input"
          />
        </div>
        <Select value={stageFilter} onValueChange={setStageFilter}>
          <SelectTrigger className="w-full md:w-[200px] bg-[#0A0A35] border-[#1E1E5F] text-white">
            <Filter className="h-4 w-4 mr-2" />
            <SelectValue placeholder="Filtrar por etapa" />
          </SelectTrigger>
          <SelectContent className="bg-[#0A0A35] border-[#1E1E5F]">
            <SelectItem value="all" className="text-white">Todas las etapas</SelectItem>
            {activePipelineStages.map((key) => (
              <SelectItem key={key} value={key} className="text-white">
                {stageConfig[key].label}
              </SelectItem>
            ))}
            <SelectItem value="GANADA" className="text-[#42E695]">Ganadas</SelectItem>
            <SelectItem value="PERDIDA" className="text-red-400">Perdidas</SelectItem>
          </SelectContent>
        </Select>
        <Button
          variant={showClosed ? "default" : "outline"}
          onClick={() => setShowClosed(!showClosed)}
          className={showClosed ? "bg-[#03BEE4] text-white" : "border-[#1E1E5F] text-slate-300"}
        >
          {showClosed ? "Mostrando cerradas" : "Mostrar cerradas"}
        </Button>
      </div>
    </CardContent>
  </Card>
);
